_ = require 'underscore'

standings =
  'none': -1
  'new': 0
  'processing': 1
  'denied': 2
  'good': 3
  'overdue': 4
  'disabled': 5
  'cancelled': 6
  'change processing': 7
  'change denied': 8
  'change finished': 9
  'authorizing': 10
  'product specific processing': 11
  'free trial': 12
  'pending product specific processing': 13
  'pending authorizing': 14
  'deleted': 15

reverseStandings = _.invert(standings)

activeStandings = [3, 4, 7, 8, 9, 11, 12, 13, 14]
processingStandings = [1, 7, 10, 11, 13, 14]
overdueStandings = [4]
needsCCStandings = [2, 5]
cancelledStandings = [6]

module.exports = Accounts =
  hasAccount: (standing) -> standing? && standing != standings.none
  isActive: (paidAccount) ->
    paidAccount? &&
    Number(paidAccount.standing) in activeStandings &&
    !_.isEmpty(paidAccount.products)
  isProcessing: (standing) -> Accounts.hasAccount(standing) && Number(standing) in processingStandings
  isProblem: (standing) -> standing == standings.overdue
  isCancelled: (paidAccount) ->
    if !paidAccount?
      return false
    standing = Number(paidAccount.standing)
    Accounts.hasAccount(paidAccount.standing) && (standing in cancelledStandings || (standing in activeStandings && standing !in processingStandings && _.isEmpty paidAccount.products))
  willExpire: (paidAccount) -> paidAccount.products?[0] of (paidAccount.expirationDates ? {})
  needsCC: (standing) -> Number(standing) in needsCCStandings
  isInactive: (standing) -> Accounts.hasAccount(standing) && !Accounts.isActive(standing)
  standingName: (standing) -> reverseStandings[standing]



// WEBPACK FOOTER //
// ./app/scripts/lib/accounts.coffee